module.exports = __webpack_public_path__ + "img/accompagnements.af3b9477.svg";